import { Order } from '@/types'
import { getCustomerInfo } from '@/utils/format'
import { Badge, Group, Paper, Stack, Text, UnstyledButton } from '@mantine/core'
import { IconPackage } from '@tabler/icons-react'
import dayjs from 'dayjs'

interface CourierOrderSummaryCardProps {
  order: Order
  onClick: () => void
}

function CourierOrderSummaryCard({ order, onClick }: CourierOrderSummaryCardProps) {
  return (
    <UnstyledButton onClick={onClick} style={{ width: '100%' }}>
      <Paper p="md" radius="md" withBorder>
        <Group justify="space-between" align="center">
          <Group>
            <Stack gap={2}>
              <Text fw={600} size="md">
                {getCustomerInfo(order).name}
              </Text>
              <Text size="xs" c="dimmed">
                Créée le {dayjs(order.created_at).format('D MMM HH:mm')}
              </Text>
            </Stack>
          </Group>

          <Badge size="lg" variant="light" color="blue" leftSection={<IconPackage size={14} />}>
            {order.articles.length} article{order.articles.length > 1 ? 's' : ''}
          </Badge>
        </Group>
      </Paper>
    </UnstyledButton>
  )
}

export default CourierOrderSummaryCard
